import styled, { css } from 'styled-components';

import { styledMedia } from '@pkg/primitives';

interface AttachedIconWrapperProps {
    $circle?: boolean;
}

export const AttachedIconWrapper = styled.div<AttachedIconWrapperProps>`
    ${styledMedia.iconWrapper};
    position: relative;
    flex: 0 0 auto;
    width: var(--yat_chip-icon-size);
    height: var(--yat_chip-icon-size);

    ${({ $circle }) =>
        $circle &&
        css`
            &::before {
                content: '';
                position: absolute;
                top: var(--yat_chip-circle-icon-offset);
                right: var(--yat_chip-circle-icon-offset);
                bottom: var(--yat_chip-circle-icon-offset);
                left: var(--yat_chip-circle-icon-offset);
                display: block;
                border-radius: 50%;
                background-color: ${({ theme }) => theme.shades.white[10]};
            }
        `};

    // TODO: Consider scoping 'child' selectors within 'Interior'.
    &:first-child {
        margin-left: var(--yat_chip-icon-offset);
    }

    &:last-child {
        margin-right: var(--yat_chip-icon-offset);
    }

    // TODO: This wouldn't be necessary if we are
    // reliably working with monotone assets.
    svg path {
        fill: currentColor;
    }
`;
